import { ForwardedRef, forwardRef, HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from './description.theme';

const elements = {
	description: styled.span`
		font: ${theme.getValue('baseFont')};
		color: ${theme.getValue('baseTextColor')};
	`,
};

interface CellulaDescriptionProps extends HTMLAttributes<HTMLSpanElement> {
	children: ReactNode;
}

function CellulaDescription({ children, ...rest }: CellulaDescriptionProps, ref: ForwardedRef<HTMLSpanElement>): JSX.Element | null {
	if (!children) {
		return null;
	}

	return (
		<elements.description {...rest} ref={ref}>
			{children}
		</elements.description>
	);
}

const Description = forwardRef(CellulaDescription);

export type { CellulaDescriptionProps };
export { Description };
